// @flow strict

import _ from 'lodash';
import React, { type Node } from 'react';
import styled from 'styled-components';

import BREAKPOINTS from 'client/constants/styles/breakpoints';
import Translate from 'client/components/translate';

const FunnelHeaderContainer = styled.div`
  margin-bottom: 1rem;
  margin-top: ${props => props.marginTop};
  padding-left: 1rem;
  padding-right: 1rem;
  text-align: center;

  @media screen and (max-width: ${BREAKPOINTS.MEDIUM}) {
    margin: ${props => props.mobileMargin};
  }
`;

type Props = {
  children?: Node,
  marginTop?: string,
  mobileMargin?: string,
  path?: string,
  subheaderPath: string | null,
  using: {
    [key: string]: *,
  },
};

export default function FunnelHeader(props: Props) {
  const { children, marginTop, mobileMargin, path, subheaderPath, using } = props;
  return (
    <FunnelHeaderContainer marginTop={marginTop} mobileMargin={mobileMargin}>
      <h3 className="funnel-header">
        {!_.isEmpty(children) ? children : path && <Translate path={path} using={using} />}
      </h3>
      {subheaderPath != null && (
        <h5 className="funnel-subheader margin">
          <Translate path={subheaderPath} />
        </h5>
      )}
    </FunnelHeaderContainer>
  );
}

FunnelHeader.defaultProps = {
  children: null,
  marginTop: '2rem',
  mobileMargin: '',
  path: '',
  subheaderPath: null,
  using: {},
};
